import {AbstractModel} from './abstract-model';
import {AdvertisingPlatform} from './advertising-platform';
import {Partner} from './partner/partner';
import {Currency} from './currency';

export class ConversionEvent extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  name: string | null = null;
  eventId: string | null = null;
  advertisingPlatform: AdvertisingPlatform | null = null;
  advertisingPlatformStatus: string | null = null;
  advertisingPlatformResult: string | null = null;
  partner: Partner | null = null;
  clickId: number | null = null;
  leadId: number | null = null;
  conversionId: number | null = null;
  amount: number | null = null;
  currency: Currency | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.advertisingPlatform) {
      this.advertisingPlatform = new AdvertisingPlatform().deserialize(input.advertisingPlatform);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    return this;
  }
}
